import { render, staticRenderFns } from "./BigData.vue?vue&type=template&id=306e9c5c&scoped=true"
import script from "./BigData.vue?vue&type=script&lang=js"
export * from "./BigData.vue?vue&type=script&lang=js"
import style0 from "./BigData.vue?vue&type=style&index=0&id=306e9c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306e9c5c",
  null
  
)

export default component.exports